/* index.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zkb7n%7Bflex-shrink%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._i0dlf1ug%7Bflex-basis%3A0%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul9idpf%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1rr0%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsbftgi%7Bwidth%3A8px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3iftgi%7Bheight%3A8px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhkjmqp%7Bbackground-color%3Avar(--ds-background-selected-bold%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsbi2wt%7Bwidth%3A6px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3ii2wt%7Bheight%3A6px%7D");
import React from 'react';
import { useIntl } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';
import { cx } from '@atlaskit/css';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import { StatusIndicator, type LoadingStatus } from '@atlassian/rovo-platform-ui-components/primitives/LoadingStatusIndicator';
import { ShimmerText } from '@atlassian/rovo-platform-ui-components/primitives/ShimmerText';
import type { Conversation } from '../../types';
import { getConversationListRowLoadingStatus } from '../../utils/conversation-task-status-indicator';
import messages from './messages';
const styles = {
  shimmerTraceWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
  notificationDot: "_2rko1rr0 _1bsbftgi _4t3iftgi _bfhkjmqp",
  dotSmall: "_1bsbi2wt _4t3ii2wt"
};
function statusToFooterMessage(status: LoadingStatus): MessageDescriptor | null {
  switch (status) {
    case 'info':
      return messages.awaitingUserResponse;
    case 'error':
      return messages.errorStatusLabel;
    case 'success':
      return messages.successStatusLabel;
    default:
      return null;
  }
}

/** True when the footer should show task status copy (Done / FAILED / awaiting) beside the optional icon. */
export function shouldShowConversationTaskStatusFooter(conversation: Conversation): boolean {
  const status = getConversationListRowLoadingStatus(conversation, conversation.readStatus === false);
  return status ? statusToFooterMessage(status) !== null : false;
}

/** Status chip used in row `elemAfter` / controls: spinner, status icon, or unread dot. */
export function ConversationListRowStatusChip({
  conversation,
  showUnreadDot = true,
  testId
}: {
  conversation: Conversation;
  showUnreadDot?: boolean;
  testId?: string;
}): JSX.Element | null {
  const isUnread = conversation.readStatus === false;
  const status = getConversationListRowLoadingStatus(conversation, isUnread);
  if (status) return <StatusIndicator status={status} size="small" />;
  if (isUnread && showUnreadDot) return <Box xcss={cx(styles.notificationDot, styles.dotSmall)} testId={testId} />;
  return null;
}
export type ConversationStatusLabelProps = {
  conversation: Conversation;
  /** When false, only the text line is rendered (icon is omitted). Default true. */
  showStatusIcon?: boolean;
};

/**
 * Footer row fragment: optional {@link StatusIndicator}-aligned icon + Done / FAILED / awaiting copy
 * (shimmer when awaiting). Renders nothing when no footer label applies for this task/channel state.
 */
export function ConversationStatusLabel({
  conversation,
  showStatusIcon = false
}: ConversationStatusLabelProps): JSX.Element | null {
  const {
    formatMessage
  } = useIntl();
  const status = getConversationListRowLoadingStatus(conversation, conversation.readStatus === false);
  const labelDescriptor = status ? statusToFooterMessage(status) : null;
  const isShimmering = status === 'info';
  if (!labelDescriptor) return null;
  return <Inline alignBlock="center" space="space.050">
			{showStatusIcon && <ConversationListRowStatusChip conversation={conversation} showUnreadDot={false} />}

			{isShimmering ? <Box xcss={styles.shimmerTraceWrapper}>
					<ShimmerText size="small" truncate>
						{formatMessage(labelDescriptor)}
					</ShimmerText>
				</Box> : <Text size="small" weight="regular" maxLines={1} align="start" color="color.text.subtle">
					{formatMessage(labelDescriptor)}
				</Text>}
		</Inline>;
}